import {
  CKLayoutHorizontal,
  CKRadioGroup,
  CKRadioGroupProps,
  CKRadioNext,
} from 'clearkit';

export interface CreditOption {
  value: string;
  credits: number;
  cost: number;
}

type CreditSelectorProps = CKRadioGroupProps & {
  onChange: (value: string) => void;
  options: CreditOption[];
  plan?: 'Growth';
  value: string;
};

export const CreditSelector: React.FC<CreditSelectorProps> = ({
  options,
  value,
  plan = 'Growth',
  onChange,
  ...rest
}) => {
  const termLabel = ' per month';

  return (
    <CKRadioGroup
      {...rest}
      containerClassName="ck-box divide-y divide-gray-200 gap-0 overflow-hidden"
      onChange={onChange}
      value={value}
    >
      <CKRadioGroup.Label className="mb-4">
        Choose the {plan} plan the credits tier that's right for you
      </CKRadioGroup.Label>
      {options.map((option) => (
        <CKRadioNext
          key={option.value}
          labelClassName="relative w-full grid grid-cols-auto-1fr py-3 px-4 focus:bg-blue-50 hover:bg-blue-50 cursor-pointer"
          value={option.value}
        >
          <CKLayoutHorizontal className="w-full">
            <span className="block font-semibold">
              {option.credits.toLocaleString('en-us')} credits
              {termLabel}
            </span>
            <span>
              <strong className="font-semibold">${option.cost}</strong>
              {termLabel}
            </span>
          </CKLayoutHorizontal>
        </CKRadioNext>
      ))}
    </CKRadioGroup>
  );
};
